'use client';

import { ComponentRef, forwardRef } from 'react';
import { useLoadScript } from '@react-google-maps/api';
import { APIProvider, Map, MapProps } from '@vis.gl/react-google-maps';
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";
import { Box } from "@mui/material";

import './styles.scss';
import useIsDesktop from "@/hooks/useDesktop";
import LoadingSpinner from "@/app/__to_be_integrated/_____components/_NEW/LoadingSpinner";

const MapViewWithConsent = forwardRef<
    ComponentRef<typeof Map>,
    MapProps
>(
    ({
        mapId,
        children,
        ...props
    }, ref) => {

        const isDesktop = useIsDesktop();

        if (!mapId) throw new Error("required prop 'mapId' is not provided");

        const { isLoaded, loadError } = useLoadScript({
            googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!,
            libraries: ['marker']
        });

        if (loadError) {
            return <ErrorBox error={"Error loading maps"} />;
        }

        if (!isLoaded) {
            return <LoadingSpinner label={"Karten werden geladen ..."} />;
        }

        return (
            <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!} libraries={['marker']}>
                <Box ref={ref} sx={{ width: '100%', height: '100%' }}>
                    <Map
                        mapId={mapId}
                        style={{ width: '100%', height: '100%' }}
                        mapTypeId='terrain'
                        gestureHandling='greedy'
                        disableDefaultUI={true}
                        fullscreenControl={false}
                        zoomControl
                        zoomControlOptions={{ position: isDesktop ? google.maps.ControlPosition.LEFT_BOTTOM : google.maps.ControlPosition.RIGHT_BOTTOM }}
                        {...props}
                    >
                        {children}
                    </Map>
                </Box>
            </APIProvider>
        );
    }
)

MapViewWithConsent.displayName = 'MapViewWithConsent';
export default MapViewWithConsent;

// export default function MapViewWithConsent({
//     mapId,
//     centerCoordinates,
//     centerAddress,
//     initialZoom,
//     markers,
//     className = '',
//     ...rest
// }: MapViewProps) {
//     if (centerCoordinates && centerAddress) {
//         console.warn(`MapView '${mapId}': Both centerCoordinates and centerAddress are provided. This might lead to unexpected behavior.`);
//     }
//
//     if (!centerCoordinates && !centerAddress) {
//         console.warn(`MapView '${mapId}': No centerCoordinates or centerAddress provided. Defaulting to (0, 0).`);
//     }
//
//     const { isLoaded, loadError } = useLoadScript({
//         googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!,
//     });
//
//     const [centerLocation, setCenterLocation] = useState<LatLngLiteral | undefined>(centerCoordinates);
//
//     useEffect(() => {
//         if (isLoaded && centerAddress) {
//             const fetchLatLong = async () => {
//                 const geocoder = new google.maps.Geocoder();
//                 const latLong = await geocoder.geocode({ address: centerAddress });
//                 const location = latLong.results[0].geometry.location;
//
//                 setCenterLocation({
//                     lat: location.lat(),
//                     lng: location.lng()
//                 });
//             };
//
//             fetchLatLong();
//         }
//     }, [isLoaded, centerAddress]);
//
//     useEffect(() => {
//         if (isLoaded && markers) {
//             const fetchLatLong = async () => {
//                 const geocoder = new google.maps.Geocoder();
//
//                 for (const [index, marker] of markers.entries()) {
//
//                     let locationLiteral: LatLngLiteral;
//                     if (typeof marker.location === 'object') {
//                         locationLiteral = marker.location;
//                     } else {
//                         const latLong = await geocoder.geocode({ address: marker.location });
//                         const location = latLong.results[0].geometry.location
//                         locationLiteral = {
//                             lat: location.lat(),
//                             lng: location.lng()
//                         };
//                     }
//
//                     markers[index].view = (
//                         <AdvancedMarker
//                             key={index}
//                             position={locationLiteral}
//                         />
//                     );
//                 }
//             };
//
//             fetchLatLong();
//         }
//     }, [isLoaded, markers]);
//
//     if (loadError) {
//         return <div>Error loading maps</div>;
//     }
//
//     if (!isLoaded) {
//         return <div className="w-full h-full content-center"><LoadingSpinner/></div>;
//     }
//
//     return (
//         <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!} libraries={['marker']}>
//             {centerLocation && (
//                 <div className={`w-full h-full ${className}`}>
//                     <Map
//                         mapId={mapId}
//                         style={{ width: '100%', height: '100%' }}
//                         defaultCenter={{ lat: centerLocation.lat || 0, lng: centerLocation.lng || 0 }}
//                         defaultZoom={initialZoom || 18}
//                         mapTypeId='terrain'
//                         gestureHandling={'greedy'}
//                         disableDefaultUI={true}
//                         fullscreenControl={false}
//                         zoomControl
//                         {...rest}
//                     >
//                         {markers && markers.map((marker, index) =>
//                             cloneElement(marker.view, { key: index })
//                         )}
//                     </Map>
//                 </div>
//             )}
//         </APIProvider>
//     );
// }
